import { RepositoryFactory } from "../../api/RepositoryFactory";

import i18n from "@/plugins/i18n";
const UserRepository = RepositoryFactory.get("users");

export const users = {
  namespaced: true,
  state: {
    user: {},
    currentUser: {},
    credentials: { email: "", password: "" },
    status: {
      loading: false,
      loggedIn: false
    }
  },

  actions: {
    async login({ dispatch, commit }, { email, password }) {
      commit("SET_CREDENTIALS", { email: email, password: password });

      commit("LOADING", true);
      let success = false;
      await UserRepository.login(email, password)
        .then(user => {
          user.data.role = "SuperAdmin"
          commit("LOGIN_USER", user.data);
          success = true;
          commit("LOADING", false);
        })
        .catch(() => {
          commit("LOGIN_FAILED");
          commit("LOADING", false);
          dispatch("alert/error", i18n.t("user.signInFailed"), { root: true });
        });

      return success;
    },

    async logout({ dispatch, commit }) {
      commit("LOGOUT_USER");
      dispatch("tag/resetState", null, { root: true });
      commit("LOADING", false);
    }
  },

  mutations: {
    LOADING(state, status) {
      state.status.loading = status;
    },

    GET_USER(state, user) {
      state.user = user;
    },

    SET_CREDENTIALS(state, credentials) {
      state.credentials = credentials;
    },

    EDIT_USER(state, user) {
      state.user = user;
    },

    LOGIN_USER(state, user) {
      state.currentUser = user;
      state.status.loggedIn = true;
    },

    LOGIN_FAILED(state) {
      state.status.loggedIn = false;
    },

    // eslint-disable-next-line
    LOGOUT_USER(state) {
      state.user = [];
      state.currentUser = {};
      state.status = {
        loading: false,
        loggedIn: false
      };
    }
  }
};
